import { render, staticRenderFns } from "./overlay-menu.vue?vue&type=template&id=774d167e&"
import script from "./overlay-menu.vue?vue&type=script&lang=js&"
export * from "./overlay-menu.vue?vue&type=script&lang=js&"
import style0 from "./_overlay-menu.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports